import { useMemo } from 'react';
import { API_BASE_URL } from 'src/api/axiosClient/constants';
import apiClient from 'src/api/axiosClient';
import {
  CreateShortLinkRequest,
  GetShortLinkParams,
  ShortLink,
  UpdateShortLinkRequest,
} from '../types';

export function useShortLinkApi() {
  return useMemo(
    () => ({
      getShortLinks: (params: GetShortLinkParams) => {
        return apiClient.get<{ items: ShortLink[]; count: number }>(`/links`, { params });
      },

      createShortLink: (companyId: string, data: CreateShortLinkRequest) => {
        return apiClient.post<ShortLink>(`/links`, data, { params: { companyId } });
      },

      updateShortLink: (companyId: string, linkId: string, data: UpdateShortLinkRequest) => {
        return apiClient.put<void>(`/links/${linkId}`, data, { params: { companyId } });
      },

      deleteShortLink: (companyId: string, linkId: string) => {
        return apiClient.delete<void>(`/links`, { data: { ids: [linkId] }, params: { companyId } });
      },

      resolveShortUrl: async (code: string) => {
        // use fetch instead of apiClient to send real client information like user-agent, ip address, etc required for tracking
        const response = await fetch(`${API_BASE_URL}/links/${code}`);
        const data = await response.json();
        return { data };
      },
    }),
    [],
  );
}
